(() => {
  const isAppPreview = new URLSearchParams(window.location.search).get('ws_app_preview') === '1';
  if (!isAppPreview) return;

  document.documentElement.classList.add('ws-app-mode');

  const start = () => {
    const app = document.querySelector('[data-ws-app-preview]');
    if (!app) return;

    app.hidden = false;

    const syncPreviewBarOffset = () => {
      const previewBar = document.querySelector('iframe[src*="/preview-bar/"]');
      const visible = previewBar && previewBar.getBoundingClientRect().height > 20;
      document.documentElement.classList.toggle('ws-shopify-preview-bar', Boolean(visible));
    };

    syncPreviewBarOffset();
    window.addEventListener('resize', syncPreviewBarOffset, { passive: true });
    window.addEventListener('load', syncPreviewBarOffset, { once: true });
    const previewBarObserver = new MutationObserver(() => {
      syncPreviewBarOffset();
      if (document.querySelector('iframe[src*="/preview-bar/"]')) previewBarObserver.disconnect();
    });
    previewBarObserver.observe(document.body, { childList: true, subtree: true });

    const preservePreviewTheme = (link, hash = '') => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      url.searchParams.delete('ws_app_preview');
      if (hash) url.hash = hash;
      link.href = url.toString();
    };

    app.querySelectorAll('[data-ws-store-link]').forEach((link) => preservePreviewTheme(link));
    app.querySelectorAll('[data-ws-packages-link]').forEach((link) => preservePreviewTheme(link, 'ws-packages'));

    const buttons = [...app.querySelectorAll('[data-ws-app-target]')];
    const panels = [...app.querySelectorAll('[data-ws-app-panel]')];

    const showPanel = (target) => {
      const selected = panels.find((panel) => panel.dataset.wsAppPanel === target);
      if (!selected) return;

      panels.forEach((panel) => {
        const active = panel === selected;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      buttons.forEach((button) => {
        const active = button.dataset.wsAppTarget === target;
        button.classList.toggle('is-active', active);
        if (button.closest('.ws-app-nav, .ws-app-mobile-nav')) {
          if (active) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        }
      });

      window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    buttons.forEach((button) => button.addEventListener('click', () => showPanel(button.dataset.wsAppTarget)));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
